// Phone validation rules for all countries
export const PHONE_VALIDATION_RULES = {
  "Afghanistan": { min: 9, max: 9 },
  "Albania": { min: 9, max: 9 },
  "Algeria": { min: 9, max: 9 },
  "Andorra": { min: 6, max: 9 },
  "Angola": { min: 9, max: 9 },
  "Argentina": { min: 10, max: 11 },
  "Armenia": { min: 8, max: 8 },
  "Australia": { min: 9, max: 10 },
  "Austria": { min: 10, max: 14 },
  "Azerbaijan": { min: 9, max: 9 },
  "Bahrain": { min: 8, max: 8 },
  "Bangladesh": { min: 10, max: 11 },
  "Belarus": { min: 9, max: 9 },
  "Belgium": { min: 9, max: 9 },
  "Belize": { min: 7, max: 7 },
  "Benin": { min: 8, max: 8 },
  "Bhutan": { min: 8, max: 8 },
  "Bolivia": { min: 8, max: 8 },
  "Bosnia and Herzegovina": { min: 8, max: 9 },
  "Botswana": { min: 8, max: 8 },
  "Brazil": { min: 10, max: 11 },
  "Brunei": { min: 7, max: 7 },
  "Bulgaria": { min: 8, max: 9 },
  "Burkina Faso": { min: 8, max: 8 },
  "Burundi": { min: 8, max: 8 },
  "Cambodia": { min: 8, max: 9 },
  "Cameroon": { min: 9, max: 9 },
  "Canada": { min: 10, max: 10 },
  "Cape Verde": { min: 7, max: 7 },
  "Central African Republic": { min: 8, max: 8 },
  "Chad": { min: 8, max: 8 },
  "Chile": { min: 9, max: 9 },
  "China": { min: 11, max: 11 },
  "Colombia": { min: 10, max: 10 },
  "Comoros": { min: 7, max: 7 },
  "Congo": { min: 9, max: 9 },
  "Costa Rica": { min: 8, max: 8 },
  "Croatia": { min: 8, max: 9 },
  "Cuba": { min: 8, max: 8 },
  "Cyprus": { min: 8, max: 8 },
  "Czech Republic": { min: 9, max: 9 },
  "Denmark": { min: 8, max: 8 },
  "Djibouti": { min: 8, max: 8 },
  "Dominica": { min: 10, max: 10 },
  "Dominican Republic": { min: 10, max: 10 },
  "Ecuador": { min: 9, max: 9 },
  "Egypt": { min: 10, max: 11 },
  "El Salvador": { min: 8, max: 8 },
  "Equatorial Guinea": { min: 9, max: 9 },
  "Eritrea": { min: 7, max: 7 },
  "Estonia": { min: 7, max: 8 },
  "Eswatini": { min: 8, max: 8 },
  "Ethiopia": { min: 9, max: 9 },
  "Fiji": { min: 7, max: 7 },
  "Finland": { min: 9, max: 12 },
  "France": { min: 10, max: 10 },
  "Gabon": { min: 8, max: 8 },
  "Gambia": { min: 7, max: 7 },
  "Georgia": { min: 9, max: 9 },
  "Germany": { min: 11, max: 12 },
  "Ghana": { min: 9, max: 9 },
  "Greece": { min: 10, max: 10 },
  "Grenada": { min: 10, max: 10 },
  "Guatemala": { min: 8, max: 8 },
  "Guinea": { min: 9, max: 9 },
  "Guinea-Bissau": { min: 7, max: 7 },
  "Guyana": { min: 7, max: 7 },
  "Haiti": { min: 8, max: 8 },
  "Honduras": { min: 8, max: 8 },
  "Hong Kong": { min: 8, max: 8 },
  "Hungary": { min: 9, max: 9 },
  "Iceland": { min: 7, max: 7 },
  "India": { min: 10, max: 10 },
  "Indonesia": { min: 9, max: 13 },
  "Iran": { min: 10, max: 10 },
  "Iraq": { min: 10, max: 10 },
  "Ireland": { min: 9, max: 9 },
  "Israel": { min: 9, max: 9 },
  "Italy": { min: 9, max: 11 },
  "Jamaica": { min: 10, max: 10 },
  "Japan": { min: 10, max: 11 },
  "Jordan": { min: 9, max: 9 },
  "Kazakhstan": { min: 10, max: 10 },
  "Kenya": { min: 9, max: 9 },
  "Kiribati": { min: 8, max: 8 },
  "Kuwait": { min: 8, max: 8 },
  "Kyrgyzstan": { min: 9, max: 9 },
  "Laos": { min: 8, max: 10 },
  "Latvia": { min: 8, max: 8 },
  "Lebanon": { min: 7, max: 8 },
  "Lesotho": { min: 8, max: 8 },
  "Liberia": { min: 7, max: 8 },
  "Libya": { min: 9, max: 9 },
  "Liechtenstein": { min: 7, max: 7 },
  "Lithuania": { min: 8, max: 8 },
  "Luxembourg": { min: 9, max: 9 },
  "Madagascar": { min: 9, max: 9 },
  "Malawi": { min: 9, max: 9 },
  "Malaysia": { min: 9, max: 10 },
  "Maldives": { min: 7, max: 7 },
  "Mali": { min: 8, max: 8 },
  "Malta": { min: 8, max: 8 },
  "Marshall Islands": { min: 7, max: 7 },
  "Mauritania": { min: 8, max: 8 },
  "Mauritius": { min: 8, max: 8 },
  "Mexico": { min: 10, max: 10 },
  "Micronesia": { min: 7, max: 7 },
  "Moldova": { min: 8, max: 8 },
  "Monaco": { min: 8, max: 9 },
  "Mongolia": { min: 8, max: 8 },
  "Montenegro": { min: 8, max: 8 },
  "Morocco": { min: 9, max: 9 },
  "Mozambique": { min: 9, max: 9 },
  "Myanmar": { min: 8, max: 10 },
  "Namibia": { min: 9, max: 9 },
  "Nauru": { min: 7, max: 7 },
  "Nepal": { min: 10, max: 10 },
  "Netherlands": { min: 9, max: 9 },
  "New Zealand": { min: 8, max: 10 },
  "Nicaragua": { min: 8, max: 8 },
  "Niger": { min: 8, max: 8 },
  "Nigeria": { min: 10, max: 11 },
  "North Korea": { min: 10, max: 10 },
  "North Macedonia": { min: 8, max: 8 },
  "Norway": { min: 8, max: 8 },
  "Oman": { min: 8, max: 8 },
  "Pakistan": { min: 10, max: 11 },
  "Palau": { min: 7, max: 7 },
  "Panama": { min: 8, max: 8 },
  "Papua New Guinea": { min: 8, max: 8 },
  "Paraguay": { min: 9, max: 9 },
  "Peru": { min: 9, max: 9 },
  "Philippines": { min: 10, max: 10 },
  "Poland": { min: 9, max: 9 },
  "Portugal": { min: 9, max: 9 },
  "Qatar": { min: 8, max: 8 },
  "Romania": { min: 10, max: 10 },
  "Russia": { min: 10, max: 10 },
  "Rwanda": { min: 9, max: 9 },
  "Saint Kitts and Nevis": { min: 10, max: 10 },
  "Saint Lucia": { min: 10, max: 10 },
  "Saint Vincent and the Grenadines": { min: 10, max: 10 },
  "Samoa": { min: 7, max: 7 },
  "San Marino": { min: 10, max: 10 },
  "Saudi Arabia": { min: 9, max: 9 },
  "Senegal": { min: 9, max: 9 },
  "Serbia": { min: 8, max: 9 },
  "Seychelles": { min: 7, max: 7 },
  "Sierra Leone": { min: 8, max: 8 },
  "Singapore": { min: 8, max: 8 },
  "Slovakia": { min: 9, max: 9 },
  "Slovenia": { min: 8, max: 8 },
  "Solomon Islands": { min: 7, max: 7 },
  "Somalia": { min: 8, max: 9 },
  "South Africa": { min: 9, max: 9 },
  "South Korea": { min: 10, max: 11 },
  "South Sudan": { min: 9, max: 9 },
  "Spain": { min: 9, max: 9 },
  "Sri Lanka": { min: 9, max: 9 },
  "Sudan": { min: 9, max: 9 },
  "Suriname": { min: 7, max: 7 },
  "Sweden": { min: 9, max: 9 },
  "Switzerland": { min: 9, max: 9 },
  "Syria": { min: 9, max: 9 },
  "Taiwan": { min: 9, max: 9 },
  "Tajikistan": { min: 9, max: 9 },
  "Tanzania": { min: 9, max: 9 },
  "Thailand": { min: 9, max: 10 },
  "Timor-Leste": { min: 8, max: 8 },
  "Togo": { min: 8, max: 8 },
  "Tonga": { min: 7, max: 7 },
  "Trinidad and Tobago": { min: 10, max: 10 },
  "Tunisia": { min: 8, max: 8 },
  "Turkey": { min: 10, max: 10 },
  "Turkmenistan": { min: 8, max: 8 },
  "Tuvalu": { min: 7, max: 7 },
  "Uganda": { min: 9, max: 9 },
  "Ukraine": { min: 9, max: 9 },
  "United Arab Emirates": { min: 9, max: 9 },
  "United Kingdom": { min: 10, max: 11 },
  "United States": { min: 10, max: 10 },
  "Uruguay": { min: 8, max: 9 },
  "Uzbekistan": { min: 9, max: 9 },
  "Vanuatu": { min: 7, max: 7 },
  "Vatican City": { min: 10, max: 10 },
  "Venezuela": { min: 10, max: 11 },
  "Vietnam": { min: 9, max: 10 },
  "Yemen": { min: 9, max: 9 },
  "Zambia": { min: 9, max: 9 },
  "Zimbabwe": { min: 9, max: 9 }
};

export const getPhoneValidationRules = (country) => {
  return PHONE_VALIDATION_RULES[country] || { min: 7, max: 15 };
};

export const validatePhoneNumber = (number, country) => {
  const digitsOnly = number.replace(/[^0-9]/g, "");
  
  if (!digitsOnly) return true;

  if (digitsOnly.match(/^0+$/)) {
    return "Invalid contact number";
  }

  const rules = getPhoneValidationRules(country);
  
  if (digitsOnly.length === rules.min || (rules.max > rules.min && digitsOnly.length >= rules.min && digitsOnly.length <= rules.max)) {
    return true;
  }
  
  if (digitsOnly.length > rules.max) {
    return `Contact number must be ${rules.min === rules.max ? rules.min : `${rules.min}-${rules.max}`} digits`;
  }
  
  if (digitsOnly.length > 0 && digitsOnly.length < rules.min) {
    return `${digitsOnly.length}/${rules.min}`;
  }

  return true;
};